  <div [ngClass]="{'show_vertical_bar' : !_smallScreen}" #navContainer>
      <div class="d-none d-lg-block mb-lg-5" aria-hidden="true">
          <ng-content select="[menuTitle]"></ng-content>
      </div>
    <div class="search-menu-container">
      <div class="d-flex d-lg-block justify-content-between">
        <a valgButton color="tertiary-icon-right" class="d-lg-none" [routerLink]="['/']" *ngIf="!searchState">
          {{ "buttons.go_to_front_page" | translate }}
          <mat-icon [svgIcon]="SvgIcon.ArrowRightDefault"></mat-icon>
        </a>

        <valg-dk-search *ngIf="searchState || !smallScreen" [autoFocus]="smallScreen" (search)="onSearch($event)" #searchfield class="searchField" [class.d-lg-block]="true">
        </valg-dk-search>

        <button valgButton color="tertiary-icon-right" class="d-lg-none align-self-center" (click)="hide()">
          {{ "buttons.close" | translate }}
          <mat-icon [svgIcon]="SvgIcon.Close"></mat-icon>
        </button>
      </div>
      <hr class="mb-0">
    </div>
    <div class="nav-links-container" >
      <ng-content select="[menuBackLink]"></ng-content>
      <button valgButton color="small" class="mb-5" (click)="searchfield?.reset()" *ngIf="searchQuery">
        {{ 'buttons.reset_search' | translate }}
        <mat-icon [svgIcon]="SvgIcon.Close"></mat-icon>
      </button>
      <valg-sidenavigation *ngIf="searchQuery === undefined && links.length > 0"
                          [links]="links">
        <ng-container *ngIf="sidenavTitle">{{ sidenavTitle | translate }}</ng-container>
      </valg-sidenavigation>
      <ng-container *ngIf="searchQuery !== undefined">
        <ng-container *ngFor="let resultLinks of filteredLinks;let i = index">
          <valg-sidenavigation *ngIf="resultLinks.links.length > 0"
                              [links]="resultLinks.links">
            <ng-container>{{ sidenavChildTitle(resultLinks.navigationType) | translate }}</ng-container>
          </valg-sidenavigation>
        </ng-container>
      </ng-container>
    </div>
  </div>

